stimulusApp.register(
  "toast",
  class extends Stimulus.Controller {
    static targets = ["message"]

    #timeout

    connect() {
      this.#timeout = setTimeout(() => this.#dismiss(), 2000)
    }

    disconnect() {
      clearTimeout(this.#timeout)
    }

    async #dismiss() {
      this.messageTarget.classList.add("toast_closing")
      await Promise.allSettled(
        this.messageTarget
          .getAnimations()
          .map((animation) => animation.finished),
      )
      this.element.remove()
    }
  },
)
